import React, { createRef} from 'react';
import ReactDOM from 'react-dom'; 
import Header from './Header/Header'; 
import Footer from './Footer/Footer'; 
import 'regenerator-runtime/runtime';
import bulmaCollapsible from '@creativebulma/bulma-collapsible';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import './faq.scss'

type FaqStateKeys = keyof FaqState

interface FaqProps {
};

interface FaqState {
    accordion1: boolean,
    accordion2: boolean,
    accordion3: boolean, 
    accordion4: boolean, 
    accordion5: boolean, 
    accordion6: boolean, 
    accordion7: boolean, 
    accordion8: boolean

}

export class Faq extends React.Component<FaqProps, FaqState> {
  
    constructor(props: FaqProps){
        super(props); 
        
        this.collapsibles = createRef()
        this.state = {
            accordion1: false,
            accordion2: false,
            accordion3: false, 
            accordion4: false, 
            accordion5: false, 
            accordion6: false, 
            accordion7: false, 
            accordion8: false
        }


    }
    collapsibles: React.RefObject<HTMLDivElement> 
    componentDidMount(){
        this.collapsibles = bulmaCollapsible.attach(".is-collapsible", {
            container: this.collapsibles.current
        })
    }

    flipCaret = (e: React.MouseEvent) => {
        let attribute:number = parseInt(
            e.currentTarget.getAttribute("href")?.split("-")[3]!
        )
        let id:FaqStateKeys = `accordion${attribute}` as FaqStateKeys
        this.setState(prevState => ({...prevState, [id]: !prevState[id]}))
       
    }
    
    render(){
        return (
            <>
            <Header/>
                <div className="content">
                    <h1 className="s-faq-header">Frequently Asked Questions</h1>
                    <div ref={this.collapsibles} id="accordion_first">
                        <article className="message">
                            <div className="message-header">
                                <p>
                                    <a  className="s-faq-accordion-link" href="#collapsible-message-accordion-1" data-action="collapse" 
                                    onClick={this.flipCaret}
                                    >
                                    <span>
                                        {
                                            this.state.accordion1 ? <FontAwesomeIcon  icon={ faAngleUp} /> :
                                            <FontAwesomeIcon  icon={ faAngleDown} />
                                        }
                                        
                                        </span>
                                    How is SheetRocks different from Google Sheets, Excel, or Airtable? 
                                    </a>
                                </p>
                            </div>
                            <div
                                id="collapsible-message-accordion-1"
                                className="message-body is-collapsible"
                                data-parent="accordion_first"
                            >
                                <div className="message-body-content">
                                SheetRocks combines the intuitiveness of a spreadsheet, the performance of a database, and the expressiveness of modern programming ecosystems. 
                                Therefore it enables new data workflows that seamlessly cross over boundaries between teams and systems that are not possible with legacy data tools.
                                </div>
                              
                            </div>
                            <hr  className="faq-divider"/>
                        </article>
                        <article className="message">
                            <div className="message-header">
                                <p>
                               
                                    <a className="s-faq-accordion-link"href="#collapsible-message-accordion-2" data-action="collapse"
                                    onClick={this.flipCaret}
                                    >
                                    <span>
                                    {
                                            this.state.accordion2 ? <FontAwesomeIcon  icon={ faAngleUp} /> :
                                            <FontAwesomeIcon  icon={ faAngleDown} />
                                        }
                                    </span>
                                    How is SheetRocks so fast?
                                    </a>
                                </p>
                            </div>
                            <div
                                id="collapsible-message-accordion-2"
                                className="message-body is-collapsible"
                                data-parent="accordion_first"
                            >
                                <div className="message-body-content">
                                We built a brand new the spreadsheet execution engine from scratch, 
                                building it up from first principles to take advantage of modern computer architecture. 
                                It was pretty tricky!
                                
                                </div>
                              
                            </div>
                            <hr  className="faq-divider"/>
                        </article>
                        <article className="message">
                            <div className="message-header">
                                <p>
                               
                                    <a className="s-faq-accordion-link" href="#collapsible-message-accordion-3" data-action="collapse"
                                    onClick={this.flipCaret}
                                    >
                                    <span>
                                    {
                                            this.state.accordion3 ? <FontAwesomeIcon  icon={ faAngleUp} /> :
                                            <FontAwesomeIcon  icon={ faAngleDown} />
                                        }
                                    </span>
                                    How do I add a custom formula?
                                    </a>
                                </p>
                            </div>
                            <div
                                id="collapsible-message-accordion-3"
                                className="message-body is-collapsible"
                                data-parent="accordion_first"
                            >
                                <div className="message-body-content">
                                You can do that through our command line tool, SRK. SRK can be downloaded <a href="https://github.com/sheetrocks/srk" target="_blank" rel="noreferrer noopener">here.</a>  
                                </div>
                              
                            </div>
                            <hr  className="faq-divider"/>
                        </article>
                        <article className="message">
                            <div className="message-header">
                                <p>
                              
                                    <a className="s-faq-accordion-link" href="#collapsible-message-accordion-4" data-action="collapse"
                                    onClick={this.flipCaret}
                                    >
                                    <span>
                                    {
                                            this.state.accordion4 ? <FontAwesomeIcon  icon={ faAngleUp} /> :
                                            <FontAwesomeIcon  icon={ faAngleDown} />
                                        }
                                    </span>
                                    What is SRK and do I need it to use SheetRocks? 
                                    </a>
                                </p>
                            </div>
                            <div
                                id="collapsible-message-accordion-4"
                                className="message-body is-collapsible"
                                data-parent="accordion_first"
                            >
                                <div className="message-body-content">
                                SRK is the command line tool used to upload custom formulas and visualizations. 
                                You don't need it to be able to use SheetRocks, but you will if you intend to add anything outside of the app's current features. 
                                </div>
                              
                            </div>
                            <hr  className="faq-divider"/>
                        </article>
                        <article className="message">
                            <div className="message-header">
                                <p>
                                    <a className="s-faq-accordion-link" href="#collapsible-message-accordion-5" data-action="collapse"
                                    onClick={this.flipCaret}
                                    >
                                    <span>
                                    {
                                            this.state.accordion5 ? <FontAwesomeIcon  icon={ faAngleUp} /> :
                                            <FontAwesomeIcon  icon={ faAngleDown} />
                                        }
                                    </span>
                                    How do I import an existing workbook from Google Sheets or Excel? 
                                    </a>
                                </p>
                            </div>
                            <div
                                id="collapsible-message-accordion-5"
                                className="message-body is-collapsible"
                                data-parent="accordion_first"
                            >
                                <div className="message-body-content">
                                You can import CSVs and XLSXs directly into a workbook, but formulas and formatting will not be imported. 
                                If you'd like a white-glove onboarding experience where we setup the formulas and formatting for you, you can email onboarding@sheet.rocks with the file you'd like to be setup. 
                                </div>
                              
                            </div>
                            <hr  className="faq-divider"/>
                        </article>
                        <article className="message">
                            <div className="message-header">
                                <p>
                                    <a className="s-faq-accordion-link" href="#collapsible-message-accordion-6" data-action="collapse"
                                    onClick={this.flipCaret}
                                    >
                                    <span>
                                    {
                                            this.state.accordion6 ? <FontAwesomeIcon  icon={ faAngleUp} /> :
                                            <FontAwesomeIcon  icon={ faAngleDown} />
                                        }
                                    </span>
                                    How do I report a bug? 
                                    </a>
                                </p>
                            </div>
                            <div
                                id="collapsible-message-accordion-6"
                                className="message-body is-collapsible"
                                data-parent="accordion_first"
                            >
                                <div className="message-body-content">
                                Please bring it up by chatting with us from within the app.
                                </div>
                              
                            </div>
                            <hr  className="faq-divider"/>
                        </article>
                        <article className="message">
                            <div className="message-header">
                                <p>
                                    <a className="s-faq-accordion-link" href="#collapsible-message-accordion-7" data-action="collapse"
                                    onClick={this.flipCaret}
                                    >
                                    <span>
                                    {
                                            this.state.accordion7 ? <FontAwesomeIcon  icon={ faAngleUp} /> :
                                            <FontAwesomeIcon  icon={ faAngleDown} />
                                        }
                                    </span>
                                    How do I request a feature? 
                                    </a>
                                </p>
                            </div>
                            <div
                                id="collapsible-message-accordion-7"
                                className="message-body is-collapsible"
                                data-parent="accordion_first"
                            >
                                <div className="message-body-content">
                                You can chat with us about your idea directly through the app!
                               
                                </div>
                              
                            </div>
                            <hr  className="faq-divider"/>
                        </article>
                        <article className="message">
                            <div className="message-header">
                                <p>
                                    <a className="s-faq-accordion-link" href="#collapsible-message-accordion-8" data-action="collapse"
                                    onClick={this.flipCaret}
                                    >
                                    <span>
                                    {
                                            this.state.accordion8 ? <FontAwesomeIcon  icon={ faAngleUp} /> :
                                            <FontAwesomeIcon  icon={ faAngleDown} />
                                        }
                                    </span>
                                    More questions?
                                    </a>
                                </p>
                            </div>
                            <div
                                id="collapsible-message-accordion-8"
                                className="message-body is-collapsible"
                                data-parent="accordion_first"
                            >
                                <div className="message-body-content">
                                Contact us through the app! 
                                </div>
                              
                            </div>
                            <hr  className="faq-divider"/>
                        </article>
                      
                       
                    </div>
                </div>
                <Footer/>
            </>
       )
    }

}

ReactDOM.render(
    <Faq/>, document.getElementById('root')
)


